// WARNING
// This component has been deprecated in favor of <sdx-tag></sdx-tag>.
// Do not make change in this file - it only exists for backwards compatibility.

import { Component, h, Element, Prop } from "@stencil/core"
import { getAppearance } from "../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-ribbon",
  styleUrl: "ribbon.scss",
  shadow: true,
})
export class Ribbon {
  @Element() public el!: HTMLSdxRibbonElement

  /**
   * Text content.
   */
  @Prop() public label: string = "Ribbon"

  /**
   * The colour variation.
   */
  @Prop() public theme: "" | "sales" | "hint" | "topic-dark" | "topic-light" =
    ""

  /**
   * @deprecated use theme instead.
   */
  @Prop() public design: "loop" | "bookmark" = "loop"

  /**
   * @deprecated
   */
  @Prop() public position: "left" | "right" = "right"

  /**
   * @deprecated
   */
  @Prop() public size: "small" | "normal" | "large" = "normal"

  private getComponentClassNames() {
    if (this.theme) {
      return {
        component: true,
        [this.theme]: true,
        [getAppearance(this.el)]: true,
      }
    }

    // fallback for backwards compatibility
    return {
      component: true,
      [this.design]: true,
      [this.position]: true,
      [this.size]: true,
    }
  }

  public render() {
    return (
      <div class={this.getComponentClassNames()}>
        <div class="ribbon-container">
          {!this.theme && this.design === "loop" ? (
            <div class="content">{this.label}</div>
          ) : (
            this.label
          )}
        </div>

        <div class="slot">
          <slot />
        </div>
      </div>
    )
  }
}
